export class AuthStateAction {
  public static readonly type = '[Authentication] AuthStateAction';
}
